import { mutator } from 'satcheljs';
import getStore from '../store/store';
import enableDisableService from '../actions/enableDisableService';

/**
 * Enable/disable service mutator. A disabled service is automatically
 * excluded from self-service page.
 */
export default mutator(enableDisableService, actionMessage => {
    let store = getStore();
    const service = store.services.get(actionMessage.serviceId);
    service.ExcludeFromSelfService = !actionMessage.enable;
});
